import React, { useState, useEffect, useRef, Fragment } from "react";
import { AiOutlineSearch, AiOutlineCloseCircle } from "react-icons/ai";
import useOnClickOutside from "../hooks/useOnClickOutside";
import Input from "../form/Input";

const searchArrayByKey = (array = [], key = "", searchTerm = "") => {
  try {
    return Array.from(
      new Set(
        array.filter((item) => item[key].toLowerCase().includes(searchTerm.toLowerCase())).map((item) => item[key])
      )
    ).slice(0, 5);
  } catch (err) {
    return [];
  }
};

const SearchInput = ({ label = "", tableData = [], setTableData = undefined, searchKeys = [] }) => {
  const inputRef = useRef(null);
  const searchWrapperRef = useRef(null);
  const [searchResults, setSearchResults] = useState({});
  const [displaySearchResults, setDisplaySearchResults] = useState(false);
  const [rawData, setRawData] = useState([]);

  const searchWrapperOutsideClick = useOnClickOutside(searchWrapperRef, () => {
    setSearchResults(false);
  });

  useEffect(() => {
    setRawData(tableData);
  }, []);

  const handleInputChange = (e) => {
    if (tableData.length > 0 && setTableData && searchKeys.length > 0 && inputRef.current.value.length > 0) {
      searchKeys.forEach((item) => {
        setSearchResults((prevResults) => ({
          ...prevResults,
          [item["label"]]: searchArrayByKey(tableData, item["key"], inputRef.current.value),
        }));
      });

      setDisplaySearchResults(true);
    }
  };

  const handleSearchItemClick = (e) => {
    const valueLabel = e.target.getAttribute("valuelabel");
    const value = e.target.getAttribute("value");

    const filteredItemKey = searchKeys.filter((item) => item["label"] === valueLabel)?.[0]?.["key"];
    const filteredData = [...tableData.filter((dt) => dt[filteredItemKey].toLowerCase() === value.toLowerCase())];

    if (filteredData.length > 0) {
      setTableData(filteredData);
      setDisplaySearchResults(false);
      inputRef.current.value = value;
    }
  };

  const clearSearch = () => {
    setDisplaySearchResults(false);
    setTableData(rawData);
    inputRef.current.value = "";
  };

  return (
    <div className="position-relative SearchInput" ref={searchWrapperRef}>
      <Input
        icon={<AiOutlineSearch />}
        placeholder={label}
        className="form-control w-100"
        style={{ borderColor: "#D0D2D9" }}
        ref={inputRef}
        onInput={handleInputChange}
        rightIcon={inputRef?.current?.value.length > 0 ? <AiOutlineCloseCircle onClick={clearSearch} /> : null}
      />
      {displaySearchResults && Object.keys(searchResults).length > 0 ? (
        <div className="search-results">
          {Object.keys(searchResults).map((key, index) => (
            <Fragment key={"search-results" + index}>
              <h6>{key}</h6>

              {searchResults[key].length > 0 ? (
                searchResults[key].map((searchItem, index) => (
                  <span
                    className="search-results__text"
                    key={"search-results__text" + index}
                    onClick={handleSearchItemClick}
                    value={searchItem}
                    valuelabel={key}
                  >
                    {searchItem}
                  </span>
                ))
              ) : (
                <span className="text-center">No Teams Found</span>
              )}
            </Fragment>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default SearchInput;
